import {getWithIDToken, IMSTokenParams} from "@utils/http/MSAuthAPI";


// We can use alternateHost to point to localhost for testing
// const alternateHost = 'http://localhost:5000';
const alternateHost = '';


export enum SplendInitiative {
    Ignition = "Ignition",
    DynamicPricing = "Dynamic Pricing",
    NoProgram = "No Program"
}

export interface ICustomerPotential {
    id: string;
    stage: string;
    vehicle: string;
    plan: string;

    quote_version?: number;
    // Status value mirrors the values from ZohoSign.
    quote_status?: string;

    created_date: string;
    zoho_contact_name: string;

    splend_initiative?: SplendInitiative;
    // Following fields are only present for AU customers (the defaults for dynamic pricing screen)
    vehicle_utilization?: string;
    min_period_weeks?: string;
    distance_allowance?: string;
    trip_count?: string;

}

export default async (
    customerID: string,
    country: string,
    IDTokenParams: IMSTokenParams,
    FilterClosedPotentials?: string
): Promise<ICustomerPotential[]> => {
    const queryParams: Record<string, string> = {
        country: country,
        customer_id: customerID,
    };

    if (FilterClosedPotentials !== undefined) {
        queryParams.filter_closed_potentials = FilterClosedPotentials;
    }
    let response = await getWithIDToken(
        `${alternateHost}/v1/potentials`,
        IDTokenParams,
        queryParams
    );


    return new Promise((resolve) => resolve(response.data));
};
